import actions from './actions'

export default function MlfbDocumentsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_MLFBDOCUMENT2:
      return {
        ...state,
        result2: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.LIST_MLFBDOCUMENT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_MLFBDOCUMENT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_MLFBDOCUMENT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_MLFBDOCUMENT:
      return {
        ...state,
        editing: { mlfbDocumentID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_MLFBDOCUMENT_RECIEVED ||
      actions.UPDATE_MLFBDOCUMENT_RECIEVED ||
      actions.DELETE_MLFBDOCUMENT_RECIEVED:
      return {
        ...state,
        editing: { mlfbDocumentID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
